import styled from 'styled-components';
import { Link, LinkProps } from '@reach/router';

import {
  badgeCardBg,
  black,
  blue,
  border1,
  boxShadow1,
  cardBorder,
  green,
  lightBlue,
  lightGray,
  lightRed,
  lightYellow,
} from 'utils/style/colors';
import { Box } from 'utils/style/extendable';
import { SecurityEventLevel } from 'store/entity/IUserSecurityEvent';
import Slider from 'react-slick';

interface IItemProps {
  space: boolean;
}

export const Container = styled('div')`
  flex: none;
  width: 80%;

  @media only screen and (max-width: 769px) {
    width: 100%;
  }
  display: flex;
  align-self: center;
  align-items: center;
  margin-bottom: 2em;
  flex-direction: column;
`;

export const LogoText = styled('div')`
  font-size: 50px;
  user-select: none;
`;
export const Logo = styled('div')`
  opacity: 0.7;
  // margin: 2em 0 1em 0;
  transition: all 0.3s ease;
  :hover {
    opacity: 1;
  }
  & img {
    max-width: 12rem;
  }
`;

export const Contents = styled('div')`
  flex: 1;
  display: block;
  align-self: stretch;
  flex-direction: row;
  justify-content: center;
  @media only screen and (max-width: 769px) {
    flex: none;
    flex-direction: column;
  }
`;

export const CardHeader = styled('span')`
  flex: none;
  color: gray;
  display: flex;
  margin-top: 1.5em;
  font-weight: 500;
  align-items: center;
  justify-content: center;
`;

export const Card = styled('div')`
  flex: 0.5;
  height: fit-content;
  margin: 1em;
  display: flex;
  background: var(--exact-white);
  box-shadow: ${boxShadow1};
  border-radius: 10px;
  flex-direction: column;
  @media only screen and (max-width: 769px) {
    flex: none;
  }
`;

export const ItemWrapper = styled('div')`
  padding: 0.5rem !important;
`;
export const Item = styled(Box)<LinkProps<any>>`
  flex: none;
  color: ${blue};
  height: 200px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem 1rem 1rem 1rem;
  border-radius: 25px;
  transition: all 0.3s ease;
  align-items: center;
  margin: 0;
  width: 100%;
  justify-content: flex-start;
  ${(props) => (props.color ? `background-color: ${props.color};` : '')};

  :hover {
    background-color: #dcdcdc;
  }
`;

export const CompanyItem = styled(Box)<IItemProps>`
  color: ${blue};
  transition: all 0.3s ease;
  border-radius: 25px;
  padding: 0;
  margin-bottom: 1.5em;
  box-shadow: ${boxShadow1};
`;

export const CompanyItemHead = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1em;
`;

export const CompanyItemBody = styled('div')`
  margin: 0 1em 1em;
  border-top: 1px solid #e8e8e8;
  & > div {
    text-align: center;
    flex: 1 1 50%;
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
  }
`;

export const ItemBadge = styled(Link)`
  margin: 0 0.5em;
  background-color: var(--exact-white);
  border-radius: 10px;
  padding: 5px 8px;
  :hover {
    color: ${green};
  }
`;

export const Title = styled('p')`
  color: gray;
  text-align: center;
  font-size: 11px;
`;

export const ItemsList = styled('div')`
  flex: none;
  width: 100%;
  padding: 2em;
  @media only screen and (max-width: 600px) {
    padding: 2em;
    margin: 0;
  }
  flex-direction: column;
  & > ${Item} {
    :last-child {
      margin-bottom: 0;
    }
  }
`;

export const CompanySettings = styled(Link)`
  color: ${blue};
  width: 2em;
  height: 2em;
  display: flex;
  transition: all 0.3s ease;
  align-items: center;
  border-radius: 50%;
  justify-content: center;
  :hover {
    color: var(--exact-white);
    background-color: ${blue};
  }
`;

export const ItemName = styled('span')<LinkProps<any>>`
  word-break: break-word;
  font-weight: 500;
  text-align: center;
  border-radius: 15px;
  padding: 3px 10px;
  color: black;
  box-shadow: ${boxShadow1};
  border-radius: 20px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 27px;
  width: 100%;
  @media only screen and (max-width: 600px) {
    width: 105%;
  }
  ${(props) => (props.color ? `background-color: ${props.color};` : '')};
`;

export const Avatar = styled('img')`
  padding: 5px;
  width: 8em;
  height: 8em;
  @media only screen and (max-width: 400px) {
    width: 7em;
    height: 7em;
  }
  flex-grow: 0;
  flex-shrink: 0;
  border-radius: 10px;
`;

export const LoginWarnInfo = styled('div')`
  padding: 1rem;
  display: flex;
`;

interface LogItemProps {
  level: SecurityEventLevel;
}

export const LogItem = styled.li<LogItemProps>`
  border: ${border1};
  margin-bottom: 10px;
  display: flex;
  padding: 10px 20px;
  position: relative;
  transition: all 0.3s ease;
  box-sizing: border-box;
  align-items: center;
  border-radius: 10px;
  background-color: ${({ level }) =>
    level === SecurityEventLevel.warn
      ? lightYellow
      : level === SecurityEventLevel.info
        ? lightBlue
        : lightRed};
`;

export const CarouselContainer = styled.div`
  overflow: hidden;
  margin: auto;
  height: 10rem !important;
  background: var(--exact-white);
  border-radius: 0.75rem;
  box-shadow: ${boxShadow1};
  max-width: calc(min(100vw - 4rem, 600px));
`;

export const HomePageContainer = styled.div`
  position: relative;
  top: 0;
  left: 0;
  overflow: visible;
  height: 100%;
`;

export const TaskSummeryContainer = styled.div`
  height: 100%;
  max-height: 100%;
  display: grid;
  grid-template-rows: auto minmax(50%, 1fr);
  grid-template-columns: repeat(2, minmax(300px, 1fr));

  @media screen and (min-width: 900px) and (max-width: 1100px) {
    padding: 24px 0;
  }

  @media screen and (max-width: 900px) {
    grid-template-columns: repeat(1, minmax(200px, 1fr));
    grid-template-rows: repeat(3, 1fr);
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
`;

export const SectionTitle = styled.h2`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;

  @media screen and (max-width: 900px) {
    margin-top: 2rem !important;
  }
`;

export const TaskMentionsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0 1rem;
  border-radius: 1.5rem;
  @media screen and (max-width: 900px) {
    width: 100%;
  }
`;

export const MentionIconContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: flex-end;
  padding: 0.5rem;
`;

export const TaskCardContainer = styled.div`
  width: 100%;
  min-height: 16rem;
  flex: 1;
  position: relative;
  box-shadow: ${boxShadow1};
  border-radius: 2rem;

  z-index: 1;

  @media screen and (max-width: 900px) {
    min-height: 20rem;
  }
`;

export const MentionStatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
  z-index: 0;
`;

export const TaskContentHolder = styled.div`
  height: 20rem;
  overflow: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
`;

export const TaskCardHolder = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  border-top-right-radius: 1.5rem;
  border-top-left-radius: 1.5rem;

  &:hover {
    background: ${lightGray};
    cursor: pointer;
  }
`;

export const MentionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const MentionRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem;
`;

export const MentionCountContainer = styled.div`
  font-weight: bold;
`;

export const CategorizedTasksContainer = styled.div`
  grid-row: span 2;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  padding: 0 1rem 0.25rem;

  @media screen and (max-width: 900px) {
    grid-row: span 1;

    & > h2 {
      margin: 1rem 0;
    }
  }
`;

export const TaskListViewContainer = styled.div`
  height: 100%;
  width: 100%;
  min-height: 15rem;
  box-shadow: ${boxShadow1};
  border-radius: 2rem;
  padding: 1.25rem 0.75rem;
  overflow: scroll;
`;

export const TemplateSelectorContainer = styled.div`
  height: 4rem;
  min-height: 4rem;
  overflow-x: auto;
  display: flex;
`;

export const TaskStackContainer = styled.div`
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
`;

export const RecentlyFilledItemsContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem 1rem 0.25rem;

  & > h2 {
    margin: 1rem 0;
  }

  @media screen and (max-width: 600px) {
    height: 36rem;
  }
`;

export const RecentlyFilledItemsList = styled.div`
  width: 100%;
  height: 100%;
  display: grid !important;
  padding: 1rem 0.5rem;
  grid-template-columns: repeat(2, 1fr);

  grid-gap: 0.5rem;
  overflow: hidden;
  direction: ${(props) => props.theme.direction};
  margin: 0.5rem;
  padding-inline-start: 1rem;

  @media (min-width: 900px) and (max-width: 1400px) {
    /* styles */
    grid-template-rows: repeat(5, 1fr);
    grid-template-columns: 1fr;
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const ItemsWrapper = styled.div`
  box-shadow: ${boxShadow1};
  border-radius: 2rem;
  height: 4.5rem;
  min-width: 17.5rem;
  max-width: 17.5rem;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  margin: 0 auto;

  &:hover {
    cursor: pointer;
  }
`;

export const ItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
`;

export const BadgeContainer = styled.div`
  width: 70%;
  ${(props) =>
    `background-image: linear-gradient(to ${props.theme.direction === 'rtl' ? 'left' : 'right'}, ${props.color} 0%, var(--exact-white) 100%);`}
  color: var(--exact-white);
  border-radius: 0 20px 20px 0;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: start;
  padding-inline-start: 1rem;
`;

export const ContentContainer = styled.div`
  height: 100%;
  width: 100%;
  flex-grow: 1;
  border-radius: 20px;
  padding: 0.8rem 1rem;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: ${black};
  background: ${badgeCardBg};
  border-inline-start: ${cardBorder};
  font-weight: bold;
  margin-inline-start: -5rem;
  position: relative;
`;

export const SliderContainer = styled.div`
  border-radius: 2rem;
  box-shadow: ${boxShadow1};
  height: calc(100% - 4rem);
  width: 100%;
`;

export const CustomSlider = styled(Slider)`
  height: 100% !important;
  & .slick-list {
    height: 100% !important;
  }

  .slick-prev:before,
  .slick-next:before {
    content: '';
    color: transparent !important;
    visibility: hidden !important;
  }

  & .slick-dots {
    position: absolute !important;
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    justify-content: center !important;
    bottom: 0 !important;
  }

  //@media screen and (max-width: 900px) {
  //  & .slick-dots {
  //    bottom: -5px !important;
  //  }
  //}
  //
  //@media screen and (max-width: 600px) {
  //  margin-bottom: -30px !important;
  //
  //  & .slick-dots {
  //    bottom: -10px !important;
  //  }
  //}
`;

export const DateGroupHeader = styled.h4`
  font-size: 0.8rem;
  font-weight: bold;
`;
